import React from "react";
import { useChatStore } from "../../../store/chatStore";
import { usePleaseLoginInfo } from "../../../hooks/use-please-login-info";
import { useNotificationClick } from "../hooks";
import { ListNotificationBase } from "../shared/ListNotificationBase";
import { CHAT_NOTIFICATION_CONFIG } from "../config/notificationConfigs";

/**
 * ListChatNotification component for teaching request notifications in list context
 * These notifications open a chat instead of navigating to a content page
 * Uses shared ListNotificationBase with chat-specific configuration
 */
export const ListChatNotification = ({
  notification,
  setIsNotificationsMenuOpen,
  prevNotification,
  getNotificationTypeHeadline,
  isLast = false,
}) => {
  const { _id, contributor } = notification;
  const { isProcessing, createClickHandler } = useNotificationClick(
    _id,
    setIsNotificationsMenuOpen
  );

  const { startNewChat, setIsChatOpen } = useChatStore();
  const { openPleaseLoginInfo, isLoggedIn } = usePleaseLoginInfo();

  const handleChatOpening = () => {
    if (!isLoggedIn) {
      openPleaseLoginInfo();
      return;
    }

    const chatData = {
      type: "private",
      chatTitle: contributor.username,
      receiverId: contributor._id,
      chatId: null,
      profilePicture: contributor.profilePicture,
      unreadMessagesCount: 0,
      isTeachingRequest: true,
    };
    
    startNewChat(chatData);
    setIsChatOpen(true);
  };

  const handleNotificationClick = createClickHandler(handleChatOpening, 300);

  return (
    <ListNotificationBase
      notification={notification}
      prevNotification={prevNotification}
      getNotificationTypeHeadline={getNotificationTypeHeadline}
      onClick={handleNotificationClick}
      isProcessing={isProcessing}
      isLast={isLast}
      // Chat-specific configuration
      notificationIcon={CHAT_NOTIFICATION_CONFIG.getNotificationIcon()}
      actionLabel={CHAT_NOTIFICATION_CONFIG.getActionLabel()}
      actionIcon={CHAT_NOTIFICATION_CONFIG.getActionIcon()}
      actionColor={CHAT_NOTIFICATION_CONFIG.actionColor}
      showTypeBadge={CHAT_NOTIFICATION_CONFIG.showTypeBadge}
    />
  );
};
